import React from "react";
import { Box } from "@mui/joy";
import { ExpandMoreIcon, ExpandLessIcon } from "../../../styles/StyledMUI";
import DarkCard from "../../common/DarkCard";
import DarkTypography from "../../common/DarkTypography";
import AddressComponent from "../display/AddressComponent";
import PhoneComponent from "../display/PhoneComponent";
import BirthdateComponent from "../display/BirthdayComponent";
import PhotoComponent from "../display/PhotoComponent";
import FileComponent from "../display/FileComponent";
import GdprComponent from "../display/GdprComponent";
import IconButtonCTA from "../../common/IconButtonCTA";

type ProfileCardProps = {
  firstName?: string;
  lastName?: string;
  street?: string;
  setStreet: React.Dispatch<React.SetStateAction<string | undefined>>;
  postalCode?: string;
  setPostalCode: React.Dispatch<React.SetStateAction<string | undefined>>;
  city?: string;
  setCity: React.Dispatch<React.SetStateAction<string | undefined>>;
  birthdate?: string | null;
  setBirthdate: React.Dispatch<React.SetStateAction<string | null | undefined>>;
  photo?: string | File;
  setPhoto: React.Dispatch<React.SetStateAction<string | File | undefined>>;
  medical?: File | string;
  setMedical: React.Dispatch<React.SetStateAction<File | string | undefined>>;
  phonenumber: string;
  setPhonenumber: React.Dispatch<React.SetStateAction<string>>;
  gdpr: boolean;
  setGdpr: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function ProfileCard(props: ProfileCardProps) {
  const [open, setOpen] = React.useState(false);
  return (
    <Box margin={1}>
      <DarkCard dense>
        <Box
          sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}
        >
          <Box
            sx={{ flex: 1, minWidth: 0, cursor: "pointer", userSelect: "none" }}
            role="button"
            tabIndex={0}
            aria-expanded={open}
            aria-label={
              open ? "Replier les informations du profil" : "Deplier les informations du profil"
            }
            onClick={() => setOpen((v) => !v)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setOpen((v) => !v);
              }
            }}
          >
            <DarkTypography
              level="h4"
              fontSize="16px"
              colorVariant="accent"
              sx={{ textAlign: "left" }}
            >
              {[props.firstName, props.lastName].filter(Boolean).join(" ") || "—"}
            </DarkTypography>
          </Box>
          <IconButtonCTA
            size="sm"
            ctaVariant="accent"
            aria-label={open ? "Replier le profil" : "Deplier le profil"}
            onClick={(e) => {
              e.stopPropagation();
              setOpen((v) => !v);
            }}
          >
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButtonCTA>
        </Box>
        {open && (
          <>
            <Box sx={{ mt: 1 }}>
              <DarkTypography level="h4" fontSize="14px" colorVariant="secondary">
                Adresse
              </DarkTypography>
              <AddressComponent
                street={props.street}
                postalCode={props.postalCode}
                city={props.city}
                setStreet={props.setStreet}
                setPostalCode={props.setPostalCode}
                setCity={props.setCity}
              />
            </Box>
            <Box sx={{ mt: 2 }}>
              <DarkTypography level="h4" fontSize="14px" colorVariant="secondary">
                Téléphone
              </DarkTypography>
              <PhoneComponent
                phonenumber={props.phonenumber}
                setPhonenumber={props.setPhonenumber}
              />
            </Box>
            <Box sx={{ mt: 2 }}>
              <DarkTypography level="h4" fontSize="14px" colorVariant="secondary">
                Date de naissance
              </DarkTypography>
              <BirthdateComponent
                birthdate={props.birthdate || null}
                setBirthdate={props.setBirthdate}
              />
            </Box>
            <Box sx={{ mt: 2 }}>
              <DarkTypography level="h4" fontSize="14px" colorVariant="secondary">
                Photo
              </DarkTypography>
              <PhotoComponent photo={props.photo} setPhoto={props.setPhoto} />
            </Box>
            <Box sx={{ mt: 2 }}>
              <DarkTypography level="h4" fontSize="14px" colorVariant="secondary">
                Certificat médical
              </DarkTypography>
              <FileComponent
                file={props.medical}
                setFile={props.setMedical}
                title="Certificat médical"
              />
            </Box>
            <Box sx={{ mt: 2 }}>
              <DarkTypography level="h4" fontSize="14px" colorVariant="secondary">
                Préférences de communication
              </DarkTypography>
              <GdprComponent gdpr={props.gdpr} setGdpr={props.setGdpr} />
            </Box>
          </>
        )}
      </DarkCard>
    </Box>
  );
}
